module.exports = __webpack_public_path__ + "front/img/sub-img-1-wap.ab3fa87a.png";